// AuthorConvertButton — "Save as Contact" button on search results
import { UserPlus } from 'lucide-react'
import { useState } from 'react'
import AuthorConvertModal from './AuthorConvertModal'

interface Props {
  authorString: string
  sourceDocumentId?: string
  sourceDocumentTitle?: string
  sourceType?: 'paper' | 'patent' | 'journal'
  projectId?: string
}

export default function AuthorConvertButton({ authorString, sourceDocumentId, sourceDocumentTitle, sourceType, projectId }: Props) {
  const [showModal, setShowModal] = useState(false)

  // Only render in project context
  if (!projectId) return null

  return (
    <>
      <button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setShowModal(true) }}
        title="Save as Contact"
        className="inline-flex items-center gap-1 px-1.5 py-0.5 text-xs text-sky-600 hover:text-sky-700 hover:bg-sky-50 rounded transition-colors"
      >
        <UserPlus size={12} />
      </button>

      {showModal && (
        <AuthorConvertModal
          authorString={authorString}
          sourceDocumentId={sourceDocumentId}
          sourceDocumentTitle={sourceDocumentTitle}
          sourceType={sourceType}
          projectId={projectId}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  )
}
